import {Injectable, Output, EventEmitter} from '@angular/core';
import {Subject} from 'rxjs';
import {$} from 'protractor';

@Injectable()
export class DataService {

  public $dataServicePush: Subject<any> = new Subject<string>();

  storageData: string[] = [];

  constructor() {
  }

  setStorageData(data) {

    this.storageData.push(data);
    this.$dataServicePush.next(this.storageData.length);

  }

}
